















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Textfield extends Vue {
  @Prop({
    type: String,
    default: "text",
    validator: (value: string) => ["text", "password", "email"].includes(value)
  })
  readonly type?: string;
  @Prop({ default: null }) readonly label?: string;
  @Prop() readonly value!: any;
  @Prop({ default: null }) readonly name?: string;
  @Prop({ default: "" }) readonly placeholder?: string;
  @Prop({ type: Boolean, default: false }) readonly error!: boolean;
}
